import { Pipe, PipeTransform } from '@angular/core';

import { Option } from '../model/option';
import { OptionsService } from '../services/options.service';

@Pipe({
    name: 'sixDigitsPipe'
})
export class SixDigitsPipe implements PipeTransform {


    transform(value: number) {
        let prefix: string;
        switch (value.toString().length) {
            case 4:
                prefix = '00';
                break;
            case 5:
                prefix = '0';
                break;
            default:
                prefix = '';
        }
        return `${prefix}${value}`.toString();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/six-digits.pipe.ts